











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashTopBar_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopBarNotifications_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PinnedSnackbarNotifications_query"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TopBarAvatar_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TopBarSearch_viewer"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "picture",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node ).hash = "e1ae4137bbedcbf5ee40a322abc5744f";

export default node;
